import React, { lazy, Suspense } from 'react';
import { Route, Switch, useRouteMatch, Redirect } from 'react-router-dom';
import { LoadingScreen } from '../../../util-components/screens/LoadingScreen';

const NotFoundScreen = lazy(() => import('screens/NotFoundScreen'));
const UserNotificationListScreen = lazy(() => import('./NotificationsScreen'));
const SearchNotifsScreen = lazy(() => import('./searchNotificationsScreen/SearchNotificationsScreen'));
const CreateNotifsScreen = lazy(() => import('./createNotificationsScreen/CreateNotificationsScreen'));
const ViewNotifsScreen = lazy(() => import('./viewNotificationsScreen/ViewNotificationsScreen'));

const NotificationsRouter = () => {
  const { url } = useRouteMatch();

  return (
    <Suspense fallback={<LoadingScreen />}>
      <Switch>
        <Route exact path={`${url}`} component={UserNotificationListScreen} />

        <Route exact path={`${url}/search-notifications`} component={SearchNotifsScreen} />

        <Route
          exact
          path={`${url}/create-notifications`}
          render={() => <Redirect to={`${url}/create`} />}
        />
        
        <Route exact path={`${url}/view/:id`} component={ViewNotifsScreen} />
        <Route exact path={`${url}/create`} component={CreateNotifsScreen} />
        <Route exact path={`${url}/modify/:notificationId`} component={CreateNotifsScreen} />

        <Route component={NotFoundScreen} />
      </Switch>
    </Suspense>
  );
};

export { NotificationsRouter };
